import React, { FC } from 'react';
import { StatusesTabProps } from './StatusesTabProps';
import ProjectStatusesForm from './ProjectStatusesForm';

const StatusesTab: FC<StatusesTabProps> = ({ tabType, isEdit }) => {
  switch (tabType) {
    default:
      return <ProjectStatusesForm isEdit={isEdit} />;
  }
};

export default StatusesTab;
